module.exports = __webpack_public_path__ + "print-label.3be63938fefc1773b7d0a07ad0511b79.svg";